import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiBaseUrls } from '../config/config';
import { AuthService } from '../Auth/auth.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private headersData:any = {};

  private apiUrl:any = {
    lastMonthPolicies: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthCustomers: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthProducts: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthQuotes: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthCompanies: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthCompanies_: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',

    lastMonthPolicies_: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthCustomers_: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthProducts_: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
    lastMonthQuotes_: apiBaseUrls + 'dashboard/getLastMonthsCountsForAdmin/',
  };
  
  constructor(private authService: AuthService, private http: HttpClient) {
  }

  apiCall(apiType:any, formData:any = null) {
    let Url = this.apiUrl[apiType] + apiType;

    this.headersData = this.authService.setTokenHeader();
    if (apiType.endsWith('_') && formData && formData.id) {
    Url += `/${formData.id}`;
  }
    switch(apiType) {
      case 'lastMonthPolicies':
        return this.http.get(Url, this.headersData);
      break;

      case 'lastMonthCustomers':
        return this.http.get(Url, this.headersData);
      break;

      case 'lastMonthProducts':
        return this.http.get(Url, this.headersData);
      break;

      case 'lastMonthQuotes':
        return this.http.get(Url, this.headersData);
      break;
      case 'lastMonthPolicies_':
        return this.http.get(Url, this.headersData);
      break;

      case 'lastMonthCustomers_':
        return this.http.get(Url, this.headersData);
      break;

      case 'lastMonthProducts_':
        return this.http.get(Url, this.headersData);
      break;

      case 'lastMonthQuotes_':
        return this.http.get(Url, this.headersData);
      break;
      case 'lastMonthCompanies_':
        return this.http.get(Url, this.headersData);
      break;

      case 'lastMonthCompanies':
      default:
        return this.http.get(Url, this.headersData);
      break;
    }
  }
}
